import { Typography } from "@material-tailwind/react";

import SideBar from "../../components/sidebar.tsx/SideBar";
import GoogleMapComponent from "./Map";
import HireCard from "../../components/HireHistory/HireCard";
import { useQuery } from "react-query";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { HireHistoryResponse } from "../../models/hireHistory/hireHistoryRes";
import DefaultLoading from "../../components/common/DefaultLoading";
import ErrorLoadingState from "../../components/common/buttons/ErrorLoadingState";
import { useHistoryState } from "../../store/hireHistory/hireHistoryStore";
import EmptyHireHistory from "../../components/HireHistory/EmptyHireHistory";

function HireHistory() {
  const { selectedHistoryState, setSelectedHistoryState } = useHistoryState();
  enum TripStatus {
    Upcoming = 1,
    Ongoing = 2,
    Cancelled = 3,
    Completed = 4,
    Declined = 5,
    Pending = 6,
    Assigned = 7,
  }

  const { data, isLoading, error } = useQuery(
    "HireHistory",
    () => api.get<HireHistoryResponse>(ApiRoutes.getBoatHireHistory),
    {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: (data) => {
        console.log(data.data);

        const hireCardsDetails = data?.data.payload.data;
        if (hireCardsDetails && hireCardsDetails.length) {
          setSelectedHistoryState(hireCardsDetails[0]);
        }
      },
    }
  );

  const hireCardsDetails = data?.data.payload.data;

  if (isLoading) {
    return (
      <div className="flex w-full h-screen items-center justify-center">
        <DefaultLoading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex w-full h-screen items-center justify-center">
        <ErrorLoadingState />
      </div>
    );
  }

  return (
    <div className="md:flex">
      <SideBar />
      <div className="flex-1 p-8 ">
        <Typography   placeholder={undefined} className="text-3xl font-semibold">Hire History</Typography>
        <Typography   placeholder={undefined}className="my-4">
          See an overview of boat histroy here
        </Typography>

        {hireCardsDetails?.length === 0 ? (
          <div className="flex h-[80%] w-full justify-center items-center">
            <EmptyHireHistory />
          </div>
        ) : (
          <section className="lg:flex">
            <div className=" lg:w-[40%] py-7 lg:h-screen  lg:overflow-y-auto">
              {hireCardsDetails?.map((detail, index) => (
                <HireCard
                  key={index}
                  boatId={detail.hireHistory.boatId.toString()}
                  tripStatus={TripStatus[detail.hireHistory.status]}
                  selected={
                    detail.hireHistory.boatId ===
                    selectedHistoryState?.hireHistory?.boatId
                  }
                  onClick={() => {
                    setSelectedHistoryState(detail);
                  }}
                />
              ))}
            </div>
            <div className="w-full lg:ml-6 rounded-lg mt- lg:mt-0">
              <GoogleMapComponent
                locations={[
                  {
                    lat: selectedHistoryState!.pickupLatitude,
                    lng: selectedHistoryState!.pickupLatitude,
                  },
                  {
                    lat: selectedHistoryState!.dropOffLatitude,
                    lng: selectedHistoryState!.dropOffLatitude,
                  },
                ]}
              />
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

export default HireHistory;
